import { ViewModel, View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { measuredProductDto, product, ProductSelector } from "../../rawData/product/productSelector";
import { warehouse, WarehouseSelector } from "../../rawData/warehouse/warehouseSelector";
import { InternalTransferListViewModel } from "../internalTransferList/internalTransferList-viewModel";
import { CreateCodeConversionView } from "./createCodeConversion-view"
import { translate } from "src/common/utilities";

export class CreateCodeConversionViewModel extends ViewModel implements IPopup {
    constructor(parentViewModel: InternalTransferListViewModel) {
        super(parentViewModel);
        this._typedParent = parentViewModel;

        this.sourceLineItems = ObservableArray.create<lineItem>();
        this.destinationLineItems = ObservableArray.create<lineItem>();
        this.sourceProductSearch = new ProductSelector(this);
        this.destinationProdudtSearch = new ProductSelector(this);
        this.sourceWarehouseSelector = new WarehouseSelector(this);
        this.destinationWarehouseSelector = new WarehouseSelector(this);

        this.sourceProductSearch.onSelectionChanged = p => {
            this.addLineItem(p, this.sourceLineItems, this.sourceWarehouseSelector.selectedItem);
        };
        this.destinationProdudtSearch.onSelectionChanged = p => {
            this.addLineItem(p, this.destinationLineItems, this.destinationWarehouseSelector.selectedItem);
        }
        this.sourceWarehouseSelector.onSelectionChanged = w => {
            this.updateBalances(w, this.sourceLineItems);
            this.sourceWarehouseName = w.title;
        };
        this.destinationWarehouseSelector.onSelectionChanged = w => {
            this.updateBalances(w, this.destinationLineItems);
            this.destinationWarehouseName = w.title;
        };
    }
    closePopup(resultCode?: string) {
        this._typedParent.isShowingPopup = false;
    }
    GetDefaultView(): View<ViewModel> {
        return new CreateCodeConversionView();
    }
    public getTypeId(): string {
        return "VM-8D754AE5-558B-41A7-B31B-5B80C68A0404"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set sourceProductSearch(v: ProductSelector) { this._sourceProductSearch = v; } public get sourceProductSearch(): ProductSelector { return this._sourceProductSearch; } private _sourceProductSearch: ProductSelector;
    public set destinationProdudtSearch(v: ProductSelector) { this._destinationProdudtSearch = v; } public get destinationProdudtSearch(): ProductSelector { return this._destinationProdudtSearch; } private _destinationProdudtSearch: ProductSelector;
    public set sourceLineItems(v: ObservableArray<lineItem>) { this._sourceLineItems = v; } public get sourceLineItems(): ObservableArray<lineItem> { return this._sourceLineItems; } private _sourceLineItems: ObservableArray<lineItem>;
    public set destinationLineItems(v: ObservableArray<lineItem>) { this._destinationLineItems = v; } public get destinationLineItems(): ObservableArray<lineItem> { return this._destinationLineItems; } private _destinationLineItems: ObservableArray<lineItem>;
    public set sourceWarehouseSelector(v: WarehouseSelector) { this._sourceWarehouseSelector = v; } public get sourceWarehouseSelector(): WarehouseSelector { return this._sourceWarehouseSelector; } private _sourceWarehouseSelector: WarehouseSelector;
    public set destinationWarehouseSelector(v: WarehouseSelector) { this._destinationWarehouseSelector = v; } public get destinationWarehouseSelector(): WarehouseSelector { return this._destinationWarehouseSelector; } private _destinationWarehouseSelector: WarehouseSelector;
    public set sourceWarehouseName(v: string) { this._sourceWarehouseName = v; } public get sourceWarehouseName(): string { return this._sourceWarehouseName; } private _sourceWarehouseName: string;
    public set destinationWarehouseName(v: string) { this._destinationWarehouseName = v; } public get destinationWarehouseName(): string { return this._destinationWarehouseName; } private _destinationWarehouseName: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;

    private _typedParent: InternalTransferListViewModel;

    async updateBalances(relatedWarehouse: warehouse, lineItems: ObservableArray<lineItem>): Promise<void> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/InventoryServices/GetWarehouseBalanceByProductIds', {
                MeasuredProductIds: lineItems.map(x => {
                    return {
                        MeasuredProductId: x.measurable.id,
                        WarehouseId: relatedWarehouse.id
                    }
                }),
            });
            result.WarehouseBalances.map(p => {
                let f = lineItems.find(x => x.measurable.id === p.MeasuredProductId);
                f.balance = p.StockBalance;
                f.availableBalance = p.AccessibleBalance;
            });
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async addLineItem(product: product, lineItems: ObservableArray<lineItem>, relatedWarehouse: warehouse) {
        let measurable = product.measuredProducts[0];
        if (lineItems.filter(x => x.measurable.id == measurable.id).length > 0) {
            await this.messageBoxConfirmWarning(translate("createCodeConversion-viewModel.duplicateItem", {}), translate("createCodeConversion-viewModel.error", {}));
            return;
        }
        let item = new lineItem(this);
        item.measurable = measurable;
        item.product = product;
        item.productName = product.name;
        item.productCode = product.code;
        item.amount = 0;
        item.relatedLineItems = lineItems;
        item.index = lineItems.length + 1;
        if (relatedWarehouse == null) {
            item.balance = 0;
            item.availableBalance = 0;
        } else {
            try {
                this.isLoading = true;
                let result = await ServerConnection.callServer('/Complex/InventoryServices/GetWarehouseBalanceByProductIds', {
                    MeasuredProductIds: [{
                        WarehouseId: relatedWarehouse.id,
                        MeasuredProductId: measurable.id
                    }],
                });
                result.WarehouseBalances.map(p => {
                    item.balance = p.StockBalance;
                    item.availableBalance = p.AccessibleBalance;
                });
            } catch (ex) {
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
        lineItems.push(item);
    }
    removeLineItemFrom(relatedLineItems: ObservableArray<lineItem>, item: lineItem) {
        relatedLineItems.remove(item);
        relatedLineItems.forEach((x, i) => {
            x.index = i + 1;
        })
    }
    validate(): string[] {
        let faults: string[] = [];
        if (this.sourceWarehouseSelector.selectedItem == null) {
            faults.push(translate("createCodeConversion-viewModel.warehouseRemittanceError", {}));
        }
        if (this.destinationWarehouseSelector.selectedItem == null) {
            faults.push(translate("createCodeConversion-viewModel.warehouseReceiptError", {}));
        }
        if (this.sourceLineItems.length == 0) {
            faults.push(translate("createCodeConversion-viewModel.warehouseLineError", {}));
        } else {
            let amountsWithInvalidAmounts = this.sourceLineItems.filter(x => x.amount <= 0);
            if (amountsWithInvalidAmounts.length > 0) {
                faults.push(translate("createCodeConversion-viewModel.invalidAmountError", {
                    rowNoList: amountsWithInvalidAmounts.map(x => x.index)
                }));
            }
            let exessiveAmounts = this.sourceLineItems.filter(x => x.amount > x.availableBalance);
            if (exessiveAmounts.length > 0) {
                faults.push(translate("createCodeConversion-viewModel.remittanceError", {
                    rowNoList: exessiveAmounts.map(x => x.index)
                }));
            }
        }
        if (this.destinationLineItems.length == 0) {
            faults.push(translate("createCodeConversion-viewModel.warehouseReceiptError", {}));
        } else {
            let amountsWithInvalidAmounts = this.destinationLineItems.filter(x => x.amount <= 0);
            if (amountsWithInvalidAmounts.length > 0) {
                faults.push(translate("createCodeConversion-viewModel.receiptError", {
                    rowNoList: amountsWithInvalidAmounts.map(x => x.index)
                }));
            }
        }
        return faults;
    }
    async createTransfer() {
        let validationResult = this.validate();
        if (validationResult.length > 0) {
            await this.messageBoxConfirmWarning(validationResult.join("\r\n"), translate("createCodeConversion-viewModel.error", {}));
            return;
        }
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseTransferServices/CreateNewWarehouseTransfer', {
                FromWarehouse: this.sourceWarehouseSelector.selectedItem.id,
                ToWarehouse: this.destinationWarehouseSelector.selectedItem.id,
                Comment: this.comment,
                TransferType: 11,
                TransferTypeName: translate("createCodeConversion-viewModel.codeTransfer", {}),
                FromLineItems: this.sourceLineItems.map(x => {
                    return {
                        MeasuredProductId: x.measurable.id,
                        Amount: x.amount
                    }
                }),
                ToLineItems: this.destinationLineItems.map(x => {
                    return {
                        MeasuredProductId: x.measurable.id,
                        Amount: x.amount
                    }
                })
            });
            if (result.IsSuccessful) {
                await this.messageBoxConfirmSuccess(translate("createCodeConversion-viewModel.codeAdjustment", { code: result.Code }), translate("createCodeConversion-viewModel.successfulOperation", {}))
            }
            this.closePopup();
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class lineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: CreateCodeConversionViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent: CreateCodeConversionViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set product(v: product) { this._product = v; } public get product(): product { return this._product; } private _product: product;
    public set measurable(v: measuredProductDto) { this._measurable = v; } public get measurable(): measuredProductDto { return this._measurable; } private _measurable: measuredProductDto;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance; } private _balance: number;
    public set availableBalance(v: number) { this._availableBalance = v; } public get availableBalance(): number { return this._availableBalance; } private _availableBalance: number;
    public set amount(v: number) { this._amount = getAsNumber(v); } public get amount(): number { return this._amount; } private _amount: number;
    public set isAmountInvalid(v: boolean) { this._isAmountInvalid = v; } public get isAmountInvalid(): boolean { return this._isAmountInvalid; } private _isAmountInvalid: boolean;
    public set relatedLineItems(v: ObservableArray<lineItem>) { this._relatedLineItems = v; } public get relatedLineItems(): ObservableArray<lineItem> { return this._relatedLineItems; } private _relatedLineItems: ObservableArray<lineItem>;

    remove() {
        this._typedParent.removeLineItemFrom(this.relatedLineItems, this);
    }
}